import React from 'react';
import { Column, AspectRatio, Tag } from '@carbon/react';
import { ArrowRight } from '@carbon/icons-react';
import './ProjectCardA.scss';

const ProjectCardA = ({ title, description, imageSrc, link, tags, icon }) => {
  return (
    <Column sm={4} md={4} lg={8} className="project-card">
      <a href={link} className="project-card__link">
        <div className="project-card__content">
          <div className="project-card__text">
            <h3>{title}</h3>
            <p>{description}</p>
            {Array.isArray(tags) && tags.length > 0 && (
              <div className="project-card__tags">
                {tags.map((tag, index) => (
                  <Tag key={index} type="blue" size="md">
                    {tag}
                  </Tag>
                ))}
              </div>
            )}
            <div className="project-card__view">
              <ArrowRight size={16} />
            </div>
          </div>
          <div className="project-card__image-container">
            <Column sm={4} md={4} lg={5}>
              <img src={imageSrc} alt={title} className="project-card__image" />
            </Column>
          </div>
          {icon && <img src={icon} alt="Project icon" className="project-card__icon" />}
        </div>
      </a>
    </Column>
  );
};

ProjectCardA.defaultProps = {
  tags: [],
};

export default ProjectCardA;